import * as http from "../../index";
import Configuration from "../../../config/index";
import { createRequest } from "./utils";
export const getUrl = (orderRef) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/bankid/auth/${orderRef}/qr-code/refresh`;
    return url;
};
export const refresh = (requestOptions) => {
    const url = getUrl(requestOptions.orderRef);
    const request = createRequest();
    return http.captureStateContext(http.json(url, request));
};
